// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import moment from 'moment'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/style/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import config from './config/index'
import './permission'

Vue.use(ElementUI, {locale})
Vue.use(ElementUI, {
  size: 'small', // set element-ui default size
})
Vue.use(ElementUI)

Vue.filter('format', function (value, format) {//{{v.createTime|format('YYYY-MM-DD')}}
  if (!value || value === '') {
    return ''
  }
  return moment(value).format(format || 'YYYY-MM-DD HH:mm:ss')
});
Vue.filter('formatDate', function (value) {//{{v.createTime|formatDate}}
  if (!value || value === '') {
    return ''
  }
  return moment(value).format("YYYY-MM-DD");
});
Vue.filter('formatTime', function (value) {//{{v.createTime|formatTime}}
  if (!value || value === '') {
    return ''
  }
  return moment(value).format("HH:mm:ss");
});
Vue.filter('formatDateTime', function (value) {//{{v.createTime|formatDateTime}}
  if (!value || value === '') {
    return ''
  }
  return moment(value).format("YYYY-MM-DD HH:mm:ss");
});
Vue.filter('leftPad', function (value, size, str) {//{{ v.num|leftPad(10, '0')}}
  if (value == null || value == undefined) {
    return value;
  }
  var result = "" + value;
  if (size <= result.length) {
    return result;
  }
  var pad = (typeof str === "string" && str.length == 1) ? str : "0";
  for (var idx = result.length; idx < size; idx++) {
    result = pad + result;
  }
  return result;
});
Vue.filter('formatFileSize', function (value) {//{{v.fileSize|formatFileSize}}
  if ((value / 1024) > 1024) {
    return Math.round((value / 1024 / 1024) * Math.pow(10, 2)) / Math.pow(10, 2) + "MB";
  } else {
    return Math.round((value / 1024) * Math.pow(10, 2)) / Math.pow(10, 2) + "KB";
  }
});
Vue.filter('formatTimeMS', function (mss) {
  var minutes = parseInt((mss /  60));

  var seconds = mss %  60;

  return  minutes + " 分钟 " + seconds + " 秒 ";

});

Vue.config.productionTip = false
Vue.prototype.globalConfig = config;
Vue.prototype.basePath = '/web';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js